(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TempCustomerDeleteController',TempCustomerDeleteController);

    TempCustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'TempCustomer'];

    function TempCustomerDeleteController($uibModalInstance, entity, TempCustomer) {
        var vm = this;
        vm.tempCustomer = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TempCustomer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
